import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import GameBoard from './GameBoard';
import { startOfflineGame } from '../../services/offline/offlineGameController';
import useDocumentTitle from '../../utils/useDocumentTitle';

const VALID_DIFFICULTIES = ['easy', 'medium', 'hard'];

// Entry point for single-player mode: deals a local game against 3 bots and
// renders the same GameBoard used for online play, with no server/websocket needed.
function OfflineGame() {
    useDocumentTitle(
        'Play ZNK Offline vs Bots — No Account Needed',
        'Play ZNK against bots right in your browser. No account, no internet connection needed once loaded.'
    );

    const dispatch = useDispatch();
    const started = useRef(false);
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (started.current) return;
        started.current = true;
        const requested = searchParams.get('difficulty');
        const difficulty = VALID_DIFFICULTIES.includes(requested) ? requested : 'medium';
        startOfflineGame(dispatch, difficulty);
    }, [dispatch, searchParams]);

    return <GameBoard />;
}

export default OfflineGame;
